import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Badge } from "reactstrap";
import { ImageUpload, EditableField, Switch, Modal } from "../../components";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { set, merge, isEmpty } from "lodash";
import selectors from "./selectors";

import actions from "../../actions";
import { toast } from "react-toastify";

class TripDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      origin_trip_detail: {},
      trip_detail: {},
      posts_by_trip: null,
      query: {},
      edit_schedule: {},
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.onTripImageChange = this.onTripImageChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.removeTripImage = this.removeTripImage.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.togglePublic = this.togglePublic.bind(this);
    this.handleEditSchedule = this.handleEditSchedule.bind(this);
    this.handleAddSchedule = this.handleAddSchedule.bind(this);
    this.toggleStatus = this.toggleStatus.bind(this);
    this.handleScheduleInputChange = this.handleScheduleInputChange.bind(this);
  }

  componentDidMount() {
    const {
      getTripDetail,
      getPostsByTrip,
      match: {
        params: { id },
      },
    } = this.props;

    getTripDetail(id)
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          this.setState({
            origin_trip_detail: data.data,
            trip_detail: data.data,
          });
        } else {
          toast.error("Failed to get Trip Detail");
        }
        this.setState({
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        toast.error("Internal Server Error");
      });

    getPostsByTrip({ trip_id: id })
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          this.setState({
            posts_by_trip: data.posts,
          });
        } else {
          toast.error("Failed to get Post Detail");
        }
        this.setState({
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        toast.error("Internal Server Error");
      });
  }

  removeTripImage() {
    let { query, trip_detail } = this.state;

    merge(query, {
      deleted_image: true,
    });

    merge(trip_detail, {
      trip_image: null,
    });

    this.setState({ query, trip_detail });
  }

  onTripImageChange(e) {
    let { query, trip_detail } = this.state;
    const trip_image = e.target.files[0];
    merge(query, {
      trip_image: trip_image,
    });

    this.setState({
      query: query,
    });

    let reader = new FileReader();
    reader.onloadend = (el) => {
      trip_detail.trip_image = el.target.result;
      this.setState({
        trip_detail: trip_detail,
      });
    };

    reader.readAsDataURL(trip_image);
  }

  toggleStatus(checked) {}

  handleAddSchedule() {}

  handleEditSchedule(schedule) {
    this.setState({
      edit_schedule: schedule,
    });
    //$(`#schedule_modal`).modal('show');
  }

  handleScheduleInputChange({ target: { id, value } }) {}

  handleSave() {
    const { query } = this.state;
    const {
      updateTripPlan,
      match: {
        params: { id },
      },
    } = this.props;

    if (isEmpty(query)) {
      toast.error("Update trip plan is empty");
      return;
    }

    updateTripPlan(id, query)
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          toast.success("Trip Plan was updated successfully.");
        }
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });
  }

  handleCancel() {
    const { origin_trip_detail } = this.state;
    this.setState({
      trip_detail: origin_trip_detail,
      query: {},
    });
  }

  handleInputChange({ target: { id, value } }) {
    let { trip_detail, query } = this.state;

    set(trip_detail, id, value);
    set(query, id, value);

    this.setState({ trip_detail, query });
  }

  togglePublic(checked) {
    let { trip_detail, query } = this.state;
    set(trip_detail, "is_public", checked);
    merge(query, {
      is_public: !checked,
    });

    this.setState({
      trip_detail: trip_detail,
      query: query,
    });
  }

  renderScheduleModal() {
    let { edit_schedule } = this.state;
    if (!edit_schedule || isEmpty(edit_schedule)) return null;
    return (
      <Modal id="schedule_modal">
        <div className="modal-content">
          <div className="card">
            <div className="card-header">
              <div className="modal-heading">
                <div className="modal__title">{}</div>
                <button
                  type="button"
                  data-dismiss="modal"
                  className="close align-self-baseline"
                  aria-label="Close"
                >
                  <span>&times;</span>
                </button>
              </div>
            </div>
            <div className="card-body">
              <div className="col-xs-12">
                <div className="row">
                  <form>
                    <div className="form-group">
                      <label htmlFor="description">Description</label>
                      <input
                        type="text"
                        className="form-control"
                        id="description"
                        aria-describedby="description"
                        placeholder="Enter Description"
                        value={edit_schedule.description}
                        onChange={this.handleScheduleInputChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="address">Address</label>
                      <input
                        type="text"
                        className="form-control"
                        id="address"
                        aria-describedby="address"
                        placeholder="Enter Address"
                        value={edit_schedule.location.address}
                        onChange={this.handleScheduleInputChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="address">Status</label>
                      <Switch
                        checked={edit_schedule.status === 0 ? false : true}
                        onChange={this.toggleStatus}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  renderTripDetail() {
    const { trip_detail, query } = this.state;

    if (isEmpty(trip_detail)) return null;
    return (
      <div className="card trip-detail-card">
        <div className="card-body">
          <div className="row">
            <div className="col-12 col-sm-4 col-md-4">
              <ImageUpload
                avatar={trip_detail.trip_image}
                name="image"
                onChange={this.onTripImageChange}
              />
              <i
                className="fa fa-trash delete-trip-image"
                onClick={() => this.removeTripImage()}
              >
                {" "}
              </i>
            </div>
            <div className="col-12 col-sm-8 col-md-8">
              <div className="row trip-info-container">
                <div className="col-3">
                  <label>Title</label>
                </div>
                <div className="col-5 info-item">
                  <EditableField>
                    <div>
                      <div className="hide-on-edit static-value">
                        <span className="static-field">
                          {trip_detail.title}
                        </span>
                      </div>
                      <input
                        type="text"
                        className="dark-input sm-input show-on-edit input-field"
                        value={trip_detail.title}
                        placeholder="Trip Title"
                        id="title"
                        onChange={this.handleInputChange}
                      />
                      <div className="action" />
                    </div>
                  </EditableField>
                </div>
                <div className="col-4"></div>
              </div>
              <div className="row trip-info-container">
                <div className="col-6">
                  <div className="row">
                    <div className="col-4 info-title">
                      <label>From Date</label>
                    </div>
                    <div className="col-8 info-item">
                      <EditableField>
                        <div>
                          <div className="hide-on-edit static-value">
                            <span className="static-field">
                              {moment(trip_detail.from_trip_date).format(
                                "YYYY-MM-DD"
                              )}
                            </span>
                          </div>
                          <input
                            type="date"
                            className="dark-input sm-input show-on-edit input-field date-picker"
                            value={moment(trip_detail.from_trip_date).format(
                              "YYYY-MM-DD"
                            )}
                            id="from_trip_date"
                            onChange={this.handleInputChange}
                          />
                          <div className="action" />
                        </div>
                      </EditableField>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="row">
                    <div className="col-4 info-title">
                      <label>To Date</label>
                    </div>
                    <div className="col-8 info-item">
                      <EditableField>
                        <div>
                          <div className="hide-on-edit static-value">
                            <span className="static-field">
                              {moment(trip_detail.to_trip_date).format(
                                "YYYY-MM-DD"
                              )}
                            </span>
                          </div>
                          <input
                            type="date"
                            className="dark-input sm-input show-on-edit input-field date-picker"
                            value={moment(trip_detail.to_trip_date).format(
                              "YYYY-MM-DD"
                            )}
                            id="to_trip_date"
                            onChange={this.handleInputChange}
                          />
                          <div className="action" />
                        </div>
                      </EditableField>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row trip-info-container">
                <div className="col-3">
                  <label>Public</label>
                </div>
                <div className="col-5 info-item">
                  <Switch
                    checked={trip_detail.is_public}
                    onChange={this.togglePublic}
                  />
                </div>
                <div className="col-4"></div>
              </div>
            </div>
          </div>
        </div>
        {!isEmpty(query) ? (
          <div className="card-footer">
            <button
              className="btn btn-primary manage-profile-but"
              onClick={this.handleSave}
            >
              {"Save"}
            </button>
            <button
              className="btn btn-outline manage-profile-but"
              onClick={this.handleCancel}
            >
              {"Cancel"}
            </button>
          </div>
        ) : null}
      </div>
    );
  }

  renderOwnerDetail() {
    const {
      trip_detail: { customerInfo },
    } = this.state;
    if (isEmpty(customerInfo)) return null;
    return (
      <div className="card user-detail-card">
        <div className="card-body">
          <div className="row info-item">
            <div className="col-12">
              <div className="info-title">User Description</div>
            </div>
          </div>
          <div className="row info-item">
            <div className="col-6">
              <label>Username</label>
            </div>
            <div className="col-6">
              <span className="static-field">{customerInfo.username}</span>
            </div>
          </div>
          <div className="row info-item">
            <div className="col-6">
              <label>Email</label>
            </div>
            <div className="col-6">
              <span className="static-field">{customerInfo.email}</span>
            </div>
          </div>
          <div className="row info-item">
            <div className="col-6">
              <label>Display Name</label>
            </div>
            <div className="col-6">
              <span className="static-field">{customerInfo.display_name}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderScheudleList() {
    const {
      trip_detail: { schedules },
    } = this.state;
    if (!schedules || schedules.length === 0) return null;
    return (
      <div className="row">
        <div className="col-12 col-sm-8">
          <div className="card">
            <div className="card-body">
              <table
                className="table table-striped table-bordered table-sm"
                cellSpacing="0"
                width="100%"
              >
                <thead className="thead-light">
                  <tr>
                    <th>Description</th>
                    <th>Address</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {schedules.map((item, key) => {
                    return (
                      <tr key={key}>
                        <td>{item.description}</td>
                        <td>{item.location ? item.location.address : null}</td>
                        <td>
                          {item.status === 0 ? (
                            <Badge color="primary">started</Badge>
                          ) : item.status === 1 ? (
                            <Badge color="success">completed</Badge>
                          ) : (
                            <Badge color="warning">cancelled</Badge>
                          )}
                        </td>
                        <td>
                          <i
                            className="fa fa-pencil"
                            onClick={() => this.handleEditSchedule(item)}
                          ></i>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-4"></div>
      </div>
    );
  }

  renderPostedItems() {
    const { posts_by_trip } = this.state;
    if (!posts_by_trip) return null;
    return (
      <div className="row">
        {posts_by_trip.map((item, key) => {
          return (
            <div className="col-12 col-sm-3" key={key}>
              <div className="related-post-item">
                <img
                  className="related-post-item-image"
                  src={
                    item.mediaInfo.length > 0
                      ? item.mediaInfo[0].media_file
                      : null
                  }
                  key={key}
                  height={200}
                ></img>
                <div className="related-post-item-description">
                  {item.description}
                </div>
                <div className="related-post-item-value">
                  <div className="related-post-item-price">
                    {item.price
                      ? "Price " +
                        item.price +
                        " " +
                        item.currency.toUpperCase()
                      : null}
                  </div>
                  <div className="related-post-item-time-limit">
                    {moment(item.time_limit).format("YYYY-MM-DD")}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderScheduleModal()}
        <div className="row">
          <div className="col-sm-8 col-12">{this.renderTripDetail()}</div>
          <div className="col-sm-4 col-12">{this.renderOwnerDetail()}</div>
        </div>
        {this.renderScheudleList()}
        <div className="section-post-trip">Posts On The Trip</div>
        {this.renderPostedItems()}
      </React.Fragment>
    );
  }
}

TripDetail.propTypes = {
  isTripPlanLoaded: PropTypes.bool.isRequired,
  trip_plan: PropTypes.object.isRequired,
  getTripDetail: PropTypes.func.isRequired,
  getPostsByTrip: PropTypes.func.isRequired,
  updateTripPlan: PropTypes.func.isRequired,
};

export default connect(selectors, {
  ...actions.trip_plans,
  ...actions.posts,
})(withRouter(TripDetail));



// WEBPACK FOOTER //
// ./client/react/Admin/views/TripDetail/index.js